import { Badge } from '@/ui'
import {
  getUserById,
  selectPrimaryMembershipForUser,
} from '@/selectors/user.selectors'
import { useFetchResponse, useReselector } from '@/utils/sharedHooks'
import { canAutoGenerateBS } from './helpers'
import { EOYBookkeepingFollowupSubstep } from '@/features/year-end-module-status/yearEndModuleStatus.slice'

import { EndOfYearSubmissionStatus } from '@/features/bookkeeping/end-of-year-review/types'
import { adminGetSubmission } from '@/features/bookkeeping/end-of-year-review/actions'

export const NeedsManualBalanceSheetLabel = ({
  userId,
  year,
}: {
  userId: number
  year: string
}) => {
  const { balanceSheetGeneration } = EOYBookkeepingFollowupSubstep
  const user = useReselector(getUserById, userId)

  const submission = useFetchResponse(adminGetSubmission, userId, year)

  const needsManualBS =
    submission?.status === EndOfYearSubmissionStatus.waitingOnHeard &&
    submission?.substepIdentifier === balanceSheetGeneration

  const membership = useReselector(selectPrimaryMembershipForUser, userId)
  const canAutoGenerate = canAutoGenerateBS(
    membership?.startDate,
    user?.financialProfile?.entityChangeElectionDate
  )

  if (!canAutoGenerate && needsManualBS) {
    return (
      <Badge color="red">Manual Balance Sheet for {year} Taxes Needed</Badge>
    )
  }

  return null
}
